import { createContext, useContext, useState, type ReactNode } from 'react';

interface RegisterTokenContextType {
  naverToken: string | null;
  setNaverToken: (token: string | null) => void;
  shopbyToken: string | null;
  setShopbyToken: (token: string | null) => void;
  serviceProvider: string | null;
  setServiceProvider: (serviceProvider: string | null) => void;
}

const RegisterTokenContext = createContext<RegisterTokenContextType | null>(null);

export const useRegisterToken = () => {
  const context = useContext(RegisterTokenContext);
  if (!context) throw new Error('useRegisterToken must be used within RegisterTokenProvider');
  return context;
};

export const RegisterTokenProvider = ({ children }: { children: ReactNode }) => {
  const [naverToken, setNaverToken] = useState<string | null>(null);
  const [shopbyToken, setShopbyToken] = useState<string | null>(null);
  const [serviceProvider, setServiceProvider] = useState<string | null>(null);

  return (
    <RegisterTokenContext.Provider
      value={{
        naverToken,
        setNaverToken,
        shopbyToken,
        setShopbyToken,
        serviceProvider,
        setServiceProvider,
      }}
    >
      {children}
    </RegisterTokenContext.Provider>
  );
};
